import React from "react";

import { ActionIcon, Container, Group, Text, Avatar, Tooltip, VisuallyHidden } from "@mantine/core";
import {
  IconBrandGithubFilled,
  IconBrandXFilled,
  IconHeartFilled,
  IconCertificate,
  IconBrandProducthunt,
} from "@tabler/icons-react";

import { data } from "./data";
import logoApp from "#root/assets/logo.svg";
import classes from "./FooterLinks.module.css";

export default function FooterLinks() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => {
      const isCommunity = group.title === "Community";

      return (
        <Text<"a">
          size="md"
          key={index}
          className={classes.link}
          component="a"
          href={link.link}
          target={isCommunity ? "_blank" : undefined}
          rel={isCommunity ? "noopener noreferrer nofollow" : undefined}
        >
          {link.label}
        </Text>
      );
    });

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Avatar src={logoApp} alt="it's me" radius="sm" size="xl" />
          <Text size="xs" className={classes.description}>
            App maker with an accessibility-first mindset
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text size="sm">© {new Date().getFullYear()} Bluecornflakes. All rights reserved.</Text>
        <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap" aria-label="Social visiting widgets">
          <Tooltip
            label="Visit our X profile"
            withArrow
            position="top-end"
            arrowSize={5}
            arrowOffset={50}
            arrowPosition="side"
          >
            <ActionIcon
              component="a"
              href="https://x.com/a11yStart"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our X profile (opens in a new tab)"
              color="gray"
              size="lg"
              variant="subtle"
            >
              <IconBrandXFilled stroke={1.5} />
              <VisuallyHidden>Follow us on X</VisuallyHidden>
            </ActionIcon>
          </Tooltip>

          <Tooltip
            label="Visit our GitHub"
            withArrow
            position="top-end"
            arrowSize={5}
            arrowOffset={40}
            arrowPosition="side"
          >
            <ActionIcon
              component="a"
              href="https://github.com/br0wsa"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our GitHub repository (opens in a new tab)"
              color="gray"
              size="lg"
              variant="subtle"
            >
              <IconBrandGithubFilled stroke={1.5} />
              <VisuallyHidden>Visit our GitHub</VisuallyHidden>
            </ActionIcon>
          </Tooltip>

          <Tooltip
            label="Check our IndiePage"
            withArrow
            position="top-end"
            arrowSize={5}
            arrowOffset={50}
            arrowPosition="side"
          >
            <ActionIcon
              component="a"
              href="https://indiepa.ge/bluecornflakes"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Support us on IndiePage (opens in a new tab)"
              color="gray"
              size="lg"
              variant="subtle"
            >
              <IconHeartFilled stroke={1.5} />
              <VisuallyHidden>Support us on Producthunt</VisuallyHidden>
            </ActionIcon>
          </Tooltip>
          <Tooltip
            label="Check our ProductHunt"
            withArrow
            position="top-end"
            arrowSize={5}
            arrowOffset={50}
            arrowPosition="side"
          >
            <ActionIcon
              component="a"
              href="https://www.producthunt.com/posts/a11ystart"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Support us on producthunt (opens in a new tab)"
              color="gray"
              size="lg"
              variant="subtle"
            >
              <IconBrandProducthunt stroke={1.5} />
              <VisuallyHidden>Support us on IndiePage</VisuallyHidden>
            </ActionIcon>
          </Tooltip>

          <Tooltip
            label="OPQUAST Certified"
            withArrow
            position="top-end"
            arrowSize={5}
            arrowOffset={50}
            arrowPosition="side"
          >
            <ActionIcon
              component="a"
              href="https://directory.opquast.com/en/certificat/7MTCEJ/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bluecornflakes - Certified Opquast (opens in a new tab)"
              color="gray"
              size="lg"
              variant="subtle"
            >
              <IconCertificate stroke={1.5} />
              <VisuallyHidden>OPQUAST Certification</VisuallyHidden>
            </ActionIcon>
          </Tooltip>
        </Group>
      </Container>
    </footer>
  );
}
